// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "40775784","5545": "20927b2f","8481": "0d9b0ffb",}[chunkId] + ".css"
}